/**
 * Logger Utility
 * Wraps console methods to only log in development mode
 * In production, errors are silent (can be sent to crash reporting service)
 */

const isDevelopment = __DEV__;

export const logger = {
  /**
   * Log general information (development only)
   */
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Log warnings (development only)
   */
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Log errors
   * In production, this could send to Sentry or similar service
   */
  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error(...args);
    } else {
      // TODO: Send to crash reporting service (Sentry, Crashlytics, etc.)
      // Example: Sentry.captureException(args[0]);
    }
  },

  /**
   * Log debug information (development only)
   */
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Log info (development only)
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
};

export default logger;
